/* eslint-disable import/no-extraneous-dependencies */

function getCacheFilePath() {
  const path = require('path');
  const isCommons = process.cwd().endsWith('/scripts');
  if (isCommons) {
    return path.resolve(process.cwd(), '..', '.cms-cache.json');
  }
  return path.resolve(process.cwd(), '..', '..', '.cms-cache.json');
}

function getQueryKey(query, preview, variables) {
  const md5 = require('blueimp-md5');
  return md5(query + JSON.stringify(variables)) + preview;
}

function getCacheContent(fs) {
  try {
    return JSON.parse(fs.readFileSync(getCacheFilePath(), { encoding: 'utf-8' }));
  } catch (err) {
    return {};
  }
}

function cacheQueryContent(queryKey, messages, fs) {
  const cacheContent = getCacheContent(fs);
  cacheContent[queryKey] = messages;
  fs.writeFileSync(getCacheFilePath(), JSON.stringify(cacheContent), { encoding: 'utf-8' });
}

export default function CMSCache() {
  if (typeof window === 'undefined') {
    const fs = require('fs');
    const cacheFilePath = getCacheFilePath();
    if (!fs.existsSync(cacheFilePath)) {
      fs.writeFileSync(cacheFilePath, '{}', { encoding: 'utf-8' });
    }

    return {
      add(query, messages, { preview, variables }) {
        const queryKey = getQueryKey(query, preview, variables);
        cacheQueryContent(queryKey, messages, fs);
      },
      hasCacheEntryFor(query, { preview, variables }) {
        const queryKey = getQueryKey(query, preview, variables);
        const cacheContent = getCacheContent(fs);
        return Boolean(cacheContent[queryKey]);
      },
      queryFromCache(query, { preview, variables }) {
        const queryKey = getQueryKey(query, preview, variables);
        const cacheContent = getCacheContent(fs);
        return cacheContent[queryKey];
      },
    };
  }

  return {
    add: () => {},
    hasCacheEntryFor: () => false,
    queryFromCache: () => ({}),
  };
}
